<template>
  <span class="inline-flex items-center" :aria-label="statusLabel">
    <!-- Single tick for sent status -->
    <TickIcon v-if="status === 'sent'" :width="tickSize" :height="tickSize" :color="sentColor" />

    <!-- Double ticks for delivered status (grey) -->
    <template v-else-if="status === 'delivered'">
      <TickIcon :width="tickSize" :height="tickSize" :color="deliveredColor" />
      <TickIcon :width="tickSize" :height="tickSize" :color="deliveredColor" class="-ml-[8px]" aria-hidden="true" />
    </template>

    <!-- Double ticks for read status (green) -->
    <template v-else-if="status === 'read'">
      <TickIcon :width="tickSize" :height="tickSize" :color="readColor" />
      <TickIcon :width="tickSize" :height="tickSize" :color="readColor" class="-ml-[8px]" aria-hidden="true" />
    </template>
  </span>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { MessageStatus } from '@/apps/messages/types';
import TickIcon from '@/graphics/icons/TickIcon.vue';

export default {
  name: 'MessageBubbleStatus',
  components: { TickIcon },
  props: {
    status: {
      type: String as PropType<MessageStatus>,
      required: true,
      validator: (value: string): boolean => ['sent', 'delivered', 'read'].includes(value),
    },
    tickSize: {
      type: Number,
      default: 14,
    },
    sentColor: {
      type: String,
      default: 'currentColor', // Inherits text color (grey-text-subdued)
    },
    deliveredColor: {
      type: String,
      default: '#6e6f74', // grey.text.subdued - default grey color
    },
    readColor: {
      type: String,
      default: '#0086cc', // safety.DEFAULT - brand blue color
    },
  },
  computed: {
    statusLabel(): string {
      const labels: Record<MessageStatus, string> = {
        sent: 'Message sent',
        delivered: 'Message delivered',
        read: 'Message read',
      };
      return labels[this.status];
    },
  },
};
</script>
